import { Suspense, lazy, type ComponentProps } from 'react'

/**
 * The Cmd+J shell drawer is the OTHER xterm consumer (its tabs each spawn a
 * Terminal, via shellTabs.ts). Loading it through React.lazy is what actually keeps
 * xterm out of the initial chunk — deferring TerminalView alone did not, because
 * this drawer imported xterm eagerly too (M9). It only mounts when the drawer is
 * open, so a plain Suspense with no visible fallback is right: nothing is on screen
 * for it to jump.
 */
const ShellDrawerImpl = lazy(() =>
  import('./ShellDrawer').then((m) => ({ default: m.ShellDrawer })),
)

type Props = ComponentProps<(typeof import('./ShellDrawer'))['ShellDrawer']>

export function ShellDrawerLazy(props: Props) {
  return (
    <Suspense fallback={null}>
      <ShellDrawerImpl {...props} />
    </Suspense>
  )
}
